// extracted by mini-css-extract-plugin
export default {"Languages":"Languages_Languages__pVd00","swing-in":"Languages_swing-in__1LQMx"};